// extracted by mini-css-extract-plugin
export var boxItems = "_8b-1";
export var boxItemsLg = "_8b-2";
export var button = "_8b-7";
export var buttonHoverless = "_8b-9";
export var buttonLg = "_8b-8";
export var filterGroupBox = "_8b-0";
export var icon = "_8b-3";
export var iconSecondary = "_8b-6";
export var iconWrapper = "_8b-4";
export var iconWrapperLg = "_8b-5";
export var truncatedLabel = "_8b-a";